var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackgroundSolutions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1101,
    height: 664,
    viewBox: "0 0 1101 664",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M339 0L0 663.5H1081C1092.05 663.5 1101 654.546 1101 643.5V20C1101 8.95431 1092.05 0 1081 0H339Z",
    fill: "#3F87F4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundSolutions);
export default __webpack_public_path__ + "static/media/BackgroundSolutions.2b8cbe9758f2ede37c219bb83cd8179c.svg";
export { ForwardRef as ReactComponent };